module.exports = __webpack_public_path__ + "static/media/RP-47.7180b7ef.pdf";